import React, { useEffect, useState } from 'react';
import { event } from '@uhg-abyss/web/tools/event';
import { useSelector } from 'react-redux';
import { styled } from '@uhg-abyss/web/tools/styled';
import { LagoonContext } from '@src/AppContext';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Link } from '@uhg-abyss/web/ui/Link';
import { constants } from '../Utils/Constants';

const Wrapper = styled('div', {
  margin: '64px 0 0px 0',
});

const AccordionLinks = styled('div', {
  display: 'grid',
});

const StyledLink = styled(Link, {
  fontFamily: 'AbyssEnterpriseSansVF, Arial, sans-serif',
  fontSize: '15px',
  fontWeight: 'bold',
  marginBottom: '5px',
});

const AccordionLink = styled('div', {
  marginLeft: '35px',
  marginBottom: '10px',
});

const AccordionDescriptionText = styled('div', {
  color: '#002677',
  fontSize: '15px',
  fontFamily: 'AbyssEnterpriseSansVF, Arial, sans-serif',
});

const Heading = styled('h3', {
  color: '#002677',
  width: '624px',
  height: '32px',
  fontStyle: 'normal',
  fontWeight: '600 !important',
  fontSize: '28px !important',
  lineHeight: '32px',
});

const Description = styled('p', {
  color: 'rgb(51, 51, 51)',
  fontSize: '15px',
  fontWeight: 400,
  fontStyle: 'normal',
  lineHeight: '24px',
  letterSpacing: '0px',
  textAlign: 'left',
  marginTop: '15px',
  marginBottom: '30px',
});

export const APIsCategoryLagoon = ({ isBrowseApi }) => {
  const [filteredCards, setFilteredCards] = useState([]);
  const { navigate } = useRouter();

  const dsData = useSelector((state) => {
    return state?.GET_DS_USER_INFO || {};
  });
  const dsUserInfo = dsData?.data;
  const lagoonContext = React.useContext(LagoonContext);

  const cards = lagoonContext?.getTable('browse-apis-v2')?.getRow();

  useEffect(() => {
    const cardList =
      cards?.filter((card) => {
        return card?.active;
      }) || [];
    const dataAc = cardList?.sort((a, b) => {
      return (a?.title || '').localeCompare(b?.title || '');
    });

    if (
      !dsUserInfo?.linkedApis ||
      dsUserInfo?.stage?.length === 0 ||
      !isBrowseApi
    ) {
      setFilteredCards(dataAc || []);
      return;
    }

    // Get unique linked APIs from stage and prod
    const stageApis = dsUserInfo.linkedApis?.stage || [];
    const prodApis = dsUserInfo.linkedApis?.prod || [];
    const uniqueLinkedApis = [...new Set([...stageApis, ...prodApis])];

    // Filter out already linked APIs
    let data =
      dataAc?.filter((el) => {
        return !uniqueLinkedApis.includes(el?.title);
      }) || [];

    // Filter out Super Connector if specific APIs are linked

    if (
      constants.SUPER_CONNECTOR_APIS.some((api) => {
        return uniqueLinkedApis.includes(api);
      })
    ) {
      data = data.filter((el) => {
        return el?.title !== 'Super Connector';
      });
    }

    setFilteredCards(data);
  }, [
    isBrowseApi,
    dsUserInfo?.linkedApis?.stage?.length,
    dsUserInfo?.linkedApis?.prod?.length,
    cards?.length,
  ]);

  const onApiClicked = (route, title) => {
    // const redirect = isBrowseApi ? route : '/all-apis';

    event('INTERACTION_EVENT', {
      interactionName: title || 'Unknown API',
      interactionValue: 'view APIs',
      interactionContext: 'tile cta clicks',
    });

    navigate(route);
  };

  return (
    <Wrapper>
      {isBrowseApi ? (
        <React.Fragment>
          <Heading id="browse-api-heading">Browse APIs</Heading>
          <Description id="browse-api-description">
            See what these APIs can do to further support your practice's
            continued efforts to increase efficiency.
          </Description>
        </React.Fragment>
      ) : (
        <Heading
          id="all-apis-heading"
          css={{ marginTop: '15px', marginBottom: '30px' }}
        >
          API Categories
        </Heading>
      )}

      <Accordion
        type="multiple"
        css={{
          marginBottom: '10px',
          fontFamily: 'AbyssEnterpriseSansVF, Arial, sans-serif',
          '.abyss-accordion-header': {
            fontSize: '15px !important',
          },
        }}
      >
        {filteredCards?.map((el, i) => {
          return (
            <Accordion.Item
              key={`${el?.title || 'accordion'}-${i}`}
              value={el?.title || `item-${i}`}
            >
              <Accordion.Header
                css={{
                  fontWeight: 'bold',
                  fontSize: '15px',
                  fontFamily: 'AbyssEnterpriseSansVF, Arial, sans-serif',
                }}
              >
                <Layout.Group>
                  <IconBrand
                    id={`api-${el?.title || 'unknown'}-icon`}
                    icon={el?.icon || 'default'}
                    size={30}
                  />
                  {el?.title || 'Unknown API'}
                </Layout.Group>
              </Accordion.Header>

              <Accordion.Content
                css={{
                  backgroundColor: 'white',
                  fontFamily: 'AbyssEnterpriseSansVF, Arial, sans-serif',
                  '.abyss-accordion-content-text div': {
                    color: '#002677 !important',
                    fontSize: '15px !important',
                    fontFamily: 'AbyssEnterpriseSansVF, Arial, sans-serif',
                  },
                }}
              >
                <AccordionLinks>
                  {el?.subcategory?.map((item, index) => {
                    return (
                      <AccordionLink key={`${item?.title || 'link'}-${index}`}>
                        <StyledLink
                          onClick={() => {
                            return onApiClicked(item?.route, item?.title);
                          }}
                        >
                          {item?.title || 'Unknown'}
                        </StyledLink>
                        <AccordionDescriptionText>
                          {item?.description || 'No description available'}
                        </AccordionDescriptionText>
                      </AccordionLink>
                    );
                  })}
                </AccordionLinks>
              </Accordion.Content>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </Wrapper>
  );
};
